import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const COMMIT_IMG = 'http://geel.fp.08wx.cn/images/3967424d6caa6adadd25b595919d7d18.jpg';

export default function CommitmentSection() {
  const { t } = useTranslation();
  const commitments = [
    { icon: 'ri-code-s-slash-line', title: t('aboutPage.commit.c0.title'), desc: t('aboutPage.commit.c0.desc') },
    { icon: 'ri-shield-star-line', title: t('aboutPage.commit.c1.title'), desc: t('aboutPage.commit.c1.desc') },
    { icon: 'ri-user-star-line', title: t('aboutPage.commit.c2.title'), desc: t('aboutPage.commit.c2.desc') },
    { icon: 'ri-phone-line', title: t('aboutPage.commit.c3.title'), desc: t('aboutPage.commit.c3.desc') },
    { icon: 'ri-file-list-3-line', title: t('aboutPage.commit.c4.title'), desc: t('aboutPage.commit.c4.desc') },
    { icon: 'ri-refresh-line', title: t('aboutPage.commit.c5.title'), desc: t('aboutPage.commit.c5.desc') },
  ];

  return (
    <>
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-verified-badge-line text-primary text-sm" />
              <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('aboutPage.commit.tag')}</span>
            </div>
            <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900 mb-4">{t('aboutPage.commit.title')}</h2>
            <p className="text-gray-500 text-base max-w-2xl mx-auto">{t('aboutPage.commit.subtitle')}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {commitments.map((c, i) => (
              <div key={i} className="group flex items-start gap-5 bg-light-alt border border-primary/10 rounded-xl p-6 hover:border-primary/25 hover:-translate-y-0.5 transition-all duration-300">
                <div className="w-11 h-11 flex items-center justify-center bg-primary/10 border border-primary/20 rounded-xl flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                  <i className={`${c.icon} text-primary text-lg`} />
                </div>
                <div>
                  <h4 className="text-gray-800 font-semibold text-sm mb-2">{c.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative bg-light-section py-28 overflow-hidden">
        <div className="absolute inset-0">
          <img src={COMMIT_IMG} alt="Global Vision" className="w-full h-full object-cover object-top opacity-15" />
          <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/70 to-white/90" />
        </div>

        <div className="relative max-w-[1400px] mx-auto px-6 text-center">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full">
              <i className="ri-eye-line text-accent text-sm" />
            <span className="text-accent text-xs font-medium uppercase tracking-wider">{t('aboutPage.future.tag')}</span>
          </div>

          <h2 className="text-4xl md:text-5xl xl:text-6xl font-heading font-black text-gray-900 mb-8 leading-tight max-w-4xl mx-auto">
            {t('aboutPage.future.title1')}
            <br />
            <span className="gradient-text">{t('aboutPage.future.title2')}</span>
          </h2>

          <p className="text-gray-500 text-lg leading-relaxed max-w-3xl mx-auto mb-12">
            {t('aboutPage.future.desc1')}
            {t('aboutPage.future.desc2')}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-primary hover:bg-primary-dark text-white font-bold text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap">
              <i className="ri-message-3-line" />
              {t('aboutPage.future.btn1')}
            </Link>
            <Link to="/advantages" className="inline-flex items-center gap-2 px-8 py-4 border border-primary/30 text-primary hover:bg-primary/10 font-semibold text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap">
              {t('aboutPage.future.btn2')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
